import type { LucideIcon } from 'lucide-react';
import {
  MessageSquare,
  LibrarySquare,
  Building2,
  Settings,
  FileText,
  Bug,
  BookOpen,
  GitBranch,
  GitCompareArrows,
  Link as LinkIcon,
  FileDigit,
  ListTodo,
  BookMarked,
  Folder,
  Users,
  Shield,
  BarChart3,
  History,
  Settings2Icon,
} from 'lucide-react';

export type NavItem = {
  /** Внутренний id для key-логики; обычно совпадает с path. */
  id: string;
  /** URL для навигации. */
  path: string;
  /** Заголовок в меню. */
  label: string;
  /** Иконка из lucide-react. */
  icon: LucideIcon;
  /** Имя permission'а (как в routes.ts), нужно для фильтра. */
  permission?: string;
  /** Видна только админам. */
  adminOnly?: boolean;
  /** Доступна всем ролям. */
  allRoles?: boolean;
};

export type NavGroup = {
  id: string;
  label: string;
  items: NavItem[];
};

/**
 * Иерархия меню. Permissions берутся из имени роута без слэша (так же,
 * как делает getVisibleRoutes в core/router/routes.ts).
 */
export const navGroups: NavGroup[] = [
  {
    id: 'workspace',
    label: 'Рабочее место',
    items: [
      {
        id: 'chat',
        path: '/chat',
        label: 'Чат с ИИ',
        icon: MessageSquare,
        allRoles: true,
      },
      {
        id: 'ai-settings',
        path: '/ai-settings',
        label: 'Настройки ИИ',
        icon: Settings,
        permission: 'ai-settings',
      },
      {
        id: 'technical-task',
        path: '/technical-task',
        label: 'ТЗ',
        icon: FileText,
        permission: 'technical-task',
      },
      // {
      //   id: 'estimation',
      //   path: '/estimation',
      //   label: 'Оценки',
      //   icon: Calculator,
      //   allRoles: true,
      // },
      {
        id: 'summarizer',
        path: '/summarizer',
        label: 'Саммаризатор',
        icon: FileDigit,
        permission: 'summarizer',
      },
      {
        id: 'business',
        path: '/business',
        label: 'Общая информация',
        icon: Building2,
        permission: 'business',
      },
      {
        id: 'text-compare',
        path: '/compare',
        label: 'Сравнение текстов',
        icon: GitCompareArrows,
        allRoles: true,
      },
    ],
  },
  {
    id: 'sources',
    label: 'Источники',
    items: [
      {
        id: 'prompthub',
        path: '/prompthub',
        label: 'Промпты',
        icon: LibrarySquare,
        allRoles: true,
      },
      {
        id: 'url-sources',
        path: '/url-sources',
        label: 'URL-источники',
        icon: LinkIcon,
        allRoles: true,
      },
      {
        id: 'jira',
        path: '/jira',
        label: 'Jira',
        icon: Bug,
        permission: 'jira',
      },
      {
        id: 'confluence',
        path: '/confluence',
        label: 'Confluence',
        icon: BookOpen,
        permission: 'confluence',
      },
      {
        id: 'git',
        path: '/git',
        label: 'Git',
        icon: GitBranch,
        permission: 'git',
      },
      {
        id: 'yandex-tracker',
        path: '/yandex/tracker',
        label: 'Я.Трекер',
        icon: ListTodo,
        permission: 'yandex',
      },
      {
        id: 'yandex-wiki',
        path: '/yandex/wiki',
        label: 'Я.Вики',
        icon: BookMarked,
        permission: 'yandex',
      },
    ],
  },
  {
    id: 'admin',
    label: 'Администрирование',
    items: [
      {
        id: 'projects',
        path: '/projects',
        label: 'Проекты',
        icon: Folder,
      },
      {
        id: 'users',
        path: '/users',
        label: 'Пользователи',
        icon: Users,
        adminOnly: true,
      },
      {
        id: 'roles',
        path: '/roles',
        label: 'Роли',
        icon: Shield,
        adminOnly: true,
      },
      {
        id: 'analytics',
        path: '/analytics',
        label: 'Аналитика',
        icon: BarChart3,
        adminOnly: true,
      },
      {
        id: 'user-actions',
        path: '/user-actions',
        label: 'Журнал действий',
        icon: History,
        adminOnly: true,
      },
      {
        id: 'settings',
        path: '/settings',
        label: 'Настройки',
        icon: Settings2Icon,
        adminOnly: true,
      },
    ],
  },
];
